import React from "react";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@material-ui/core";

import SwitchButton from "../../../common/SwitchButton/SwitchButton";
import MultiSelectBox from "../../../common/MultiSelectBox/MultiSelectBox";
import defaultServiceStyles from "../DefaultServiceStyles";

import { APPLICATION_TEXT_CONSTANT, DAYS_DROPDOWN_OPTIONS } from "../../../../config/constants";

export interface AdditionalZoneConfigurationProps {
    weeklyHolidayEnabled: boolean;
    weeklyOffDays: string[];
    onHolidayEnabledChange: () => void;
    onWeeklyOffDaysChange: (selected: string[]) => void;
}

const AdditionalZoneConfiguration = ({
    weeklyHolidayEnabled,
    weeklyOffDays,
    onHolidayEnabledChange,
    onWeeklyOffDaysChange,
}: AdditionalZoneConfigurationProps) => {
    const classes = defaultServiceStyles();

    return (
        <Accordion className={classes.accordionStyle}>
            <AccordionSummary
                className={classes.accordionSummaryStyle}
                expandIcon={<ExpandMoreIcon />}
            >
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <Typography className={classes.accordionTitle}>
                            {`${APPLICATION_TEXT_CONSTANT.ADDITIONAL_ZONE_CONFIGURATION}`}
                        </Typography>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetailsStyle}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid item>
                                <Typography className={classes.accordionTitle} component="span">
                                    {APPLICATION_TEXT_CONSTANT.WEEKLY_HOLIDAYS}
                                </Typography>
                            </Grid>
                            <Grid item>
                                <SwitchButton
                                    leftLabel="Off"
                                    rightLabel="On"
                                    size="medium"
                                    checked={weeklyHolidayEnabled}
                                    handleChange={onHolidayEnabledChange}
                                    disabled={false}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                style={{
                                    visibility: weeklyHolidayEnabled ? "visible" : "hidden",
                                }}
                            >
                                <MultiSelectBox
                                    name="weeklyHolidays"
                                    label={APPLICATION_TEXT_CONSTANT.WEEKLY_HOLIDAYS}
                                    menuitems={DAYS_DROPDOWN_OPTIONS}
                                    value={weeklyOffDays}
                                    onChange={onWeeklyOffDaysChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default AdditionalZoneConfiguration;
